import React, { useEffect, useState } from "react";
import { FaExclamationTriangle, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getUnReviewedSessions } from "../../redux/slice/session-reviews/session-reviews-thunk";
import { Link } from "react-router-dom"; // Import Link from React Router

const SessionReviewsAlert = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const { unReviewedSessions } = useSelector((state) => state?.sessionReviews);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (loggedInUser?.id) {
      dispatch(getUnReviewedSessions({ studentId: loggedInUser?.id }));
    }
  }, [loggedInUser]);

  return (
    <div className="mt-2 mx-3">
      {visible && unReviewedSessions?.length > 0 && (
        <div
          className="alert alert-warning d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between shadow-sm rounded-3 px-3 py-2 position-relative"
          role="alert"
          style={{ fontSize: "0.875rem" }}
        >
          {/* Alert Message (Left Side) */}
          <div className="d-flex align-items-center mb-2 mb-sm-0">
            <FaExclamationTriangle className="me-2 flex-shrink-0" size={14} />
            <span className="fs-8" style={{ fontSize: "0.75rem" }}>
              You have{" "}
              <strong className="mx-1">{unReviewedSessions?.length}</strong>
              unreviewed session{unReviewedSessions?.length > 1 ? "s" : ""}.
              Please add your review.
            </span>
          </div>

          {/* Action Buttons (Right Side) */}
          <div
            className="d-flex align-items-center gap-2 ms-sm-auto"
            style={{ marginLeft: "auto" }}
          >
            {/* "Add Review" Button */}
            <Link
              to="/student/session-reviews"
              className="btn btn-sm btn-outline-dark"
              style={{ whiteSpace: "nowrap", fontSize: "0.7rem", padding: "2px 10px",marginRight: '1.2rem' }}
            >
              Add Review
            </Link>

            {/* Close Button (X) */}
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              style={{
                background: "none",
                border: "none",
                fontSize: "0.875rem",
                marginBottom: "0.5rem",
              }}
              onClick={() => setVisible(false)}
            >
              <FaTimes />
            </button>
          </div>
        </div>
      )}
      <style>
        {`
          @media (max-width: 576px) {
            .btn-close {
              position: absolute;
              top: 0.5rem;
              right: 0.5rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default SessionReviewsAlert;
